import { DateTime } from 'luxon'

import { PaymentPlatform } from '@/core/api/entities/payment/paymentPlatform'

export class PaymentMethod {
	public id: number
	public paymentPlatformId: number
	public paymentPlatform?: PaymentPlatform
	public name: string
	public active: boolean
	public data: PaymentPlatformMethodData
	public createdAt: DateTime
	public updatedAt: DateTime

	constructor(data: {
		id: number
		paymentPlatformId: number
		paymentPlatform?: PaymentPlatform
		name: string
		active: boolean
		data: PaymentPlatformMethodData
		createdAt: DateTime
		updatedAt: DateTime
	}) {
		this.id = data.id
		this.paymentPlatformId = data.paymentPlatformId
		this.paymentPlatform = data.paymentPlatform
		this.name = data.name
		this.active = data.active
		this.data = data.data
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
	}

	static create(data: Partial<PaymentMethod>): PaymentMethod {
		const defaultValues = {
			id: 0,
			paymentPlatformId: 0,
			paymentPlatform: undefined,
			name: '',
			active: false,
			data: PaymentPlatformMethodData.create({
				country: '',
				code: '',
				payment_type: '',
				allowed_flows: [],
				allowed: [],
			}),
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
		}
		return new PaymentMethod({ ...defaultValues, ...data })
	}
}

export class PaymentPlatformMethodData {
	public country: string
	public code: string
	public payment_type: string
	public allowed_flows: string[]
	public allowed: string[]

	constructor(data: {
		country: string
		code: string
		payment_type: string
		allowed_flows: string[]
		allowed: string[]
	}) {
		this.country = data.country
		this.code = data.code
		this.payment_type = data.payment_type
		this.allowed_flows = data.allowed_flows
		this.allowed = data.allowed
	}

	static create(
		data: Partial<PaymentPlatformMethodData>
	): PaymentPlatformMethodData {
		const defaultValues = {
			country: '',
			code: '',
			payment_type: '',
			allowed_flows: [],
			allowed: [],
		}
		return new PaymentPlatformMethodData({ ...defaultValues, ...data })
	}
}
